export const DkProductCrateDropNames = [
  'Exotic DUSTED~License Plate',
  'Epic TRYHRDR~License Plate',
  'Epic TCHGRAS~License Plate',
  'Rare WASHME~License Plate',
  'Rare WRPSPD~License Plate',
  'Rare S4V4GE~License Plate',
  'Common SYNLYFE~License Plate',
  'Common GOAT~License Plate',
  'Common OUTRUN~License Plate',
  'Common 2SLOW~License Plate',
  'Exotic Midas~SMG Weapon',
  'Epic Venom Camo~SMG Weapon',
  'Epic Midnight Flame~SMG Weapon',
  'Rare Artic Cobalt~SMG Weapon',
  'Rare Autumn Midnight~SMG Weapon',
  'Rare Gilded Crimson~SMG Weapon',
  'Common Crimson Arctic~SMG Weapon',
  'Common Hazard Gray~SMG Weapon',
  'Common Midnight Cobalt~SMG Weapon',
  'Common Midnight Hazard~SMG Weapon',
  'Exotic Midas~AR Weapon',
  'Epic Venom Camo~AR Weapon',
  'Epic Midnight Flame~AR Weapon',
  'Rare Artic Cobalt~AR Weapon',
  'Rare Autumn Midnight~AR Weapon',
  'Rare Gilded Crimson~AR Weapon',
  'Common Crimson Arctic~AR Weapon',
  'Common Hazard Gray~AR Weapon',
  'Common Midnight Cobalt~AR Weapon',
  'Common Midnight Hazard~AR Weapon',
  'Exotic Midas~Sniper Weapon',
  'Epic Venom Camo~Sniper Weapon',
  'Epic Midnight Flame~Sniper Weapon',
  'Rare Artic Cobalt~Sniper Weapon',
  'Rare Autumn Midnight~Sniper Weapon',
  'Rare Gilded Crimson~Sniper Weapon',
  'Common Crimson Arctic~Sniper Weapon',
  'Common Hazard Gray~Sniper Weapon',
  'Common Midnight Cobalt~Sniper Weapon',
  'Common Midnight Hazard~Sniper Weapon',
  'Exotic Midas~Auto Shotgun Weapon',
  'Epic Venom Camo~Auto Shotgun Weapon',
  'Epic Midnight Flame~Auto Shotgun Weapon',
  'Rare Artic Cobalt~Auto Shotgun Weapon',
  'Rare Autumn Midnight~Auto Shotgun Weapon',
  'Rare Gilded Crimson~Auto Shotgun Weapon',
  'Common Crimson Arctic~Auto Shotgun Weapon',
  'Common Hazard Gray~Auto Shotgun Weapon',
  'Common Midnight Cobalt~Auto Shotgun Weapon',
  'Common Midnight Hazard~Auto Shotgun Weapon',
  'Exotic Midas~Heavy Pistol Weapon',
  'Epic Venom Camo~Heavy Pistol Weapon',
  'Epic Midnight Flame~Heavy Pistol Weapon',
  'Rare Artic Cobalt~Heavy Pistol Weapon',
  'Rare Autumn Midnight~Heavy Pistol Weapon',
  'Rare Gilded Crimson~Heavy Pistol Weapon',
  'Common Crimson Arctic~Heavy Pistol Weapon',
  'Common Hazard Gray~Heavy Pistol Weapon',
  'Common Midnight Cobalt~Heavy Pistol Weapon',
  'Common Midnight Hazard~Heavy Pistol Weapon',
  'Exotic Midas~Upper Torso',
  'Epic Venom Camo~Upper Torso',
  'Epic Midnight Flame~Upper Torso',
  'Rare Artic Cobalt~Upper Torso',
  'Rare Autumn Midnight~Upper Torso',
  'Rare Gilded Crimson~Upper Torso',
  'Common Crimson Arctic~Upper Torso',
  'Common Hazard Gray~Upper Torso',
  'Common Midnight Cobalt~Upper Torso',
  'Common Midnight Hazard~Upper Torso',
  'Exotic Midas~Lower Torso',
  'Epic Venom Camo~Lower Torso',
  'Epic Midnight Flame~Lower Torso',
  'Rare Artic Cobalt~Lower Torso',
  'Rare Autumn Midnight~Lower Torso',
  'Rare Gilded Crimson~Lower Torso',
  'Common Crimson Arctic~Lower Torso',
  'Common Hazard Gray~Lower Torso',
  'Common Midnight Cobalt~Lower Torso',
  'Common Midnight Hazard~Lower Torso',
  'Exotic Midas~Gloves',
  'Epic Venom Camo~Gloves',
  'Epic Midnight Flame~Gloves',
  'Rare Artic Cobalt~Gloves',
  'Rare Autumn Midnight~Gloves',
  'Rare Gilded Crimson~Gloves',
  'Common Crimson Arctic~Gloves',
  'Common Hazard Gray~Gloves',
  'Common Midnight Cobalt~Gloves',
  'Common Midnight Hazard~Gloves',
  'Exotic Midas~Boots',
  'Epic Venom Camo~Boots',
  'Epic Midnight Flame~Boots',
  'Rare Artic Cobalt~Boots',
  'Rare Autumn Midnight~Boots',
  'Rare Gilded Crimson~Boots',
  'Common Crimson Arctic~Boots',
  'Common Hazard Gray~Boots',
  'Common Midnight Cobalt~Boots',
  'Common Midnight Hazard~Boots',
]
